import { render, staticRenderFns } from "./CoozzyFormRegionSelect.vue?vue&type=template&id=a0616360&scoped=true"
import script from "./CoozzyFormRegionSelect.vue?vue&type=script&lang=js"
export * from "./CoozzyFormRegionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0616360",
  null
  
)

export default component.exports